export default "<div class=\"header-title-container\">\n    <div class=\"header-title\">\n\n    </div>\n</div>\n"